import axios from "axios";
import { apiURL } from "../config";

export const uploadRingTone = async (image, data) => {
  const token = localStorage.token;
  try {
    const res = await axios.post(
      "https://api.imgbb.com/1/upload?key=120bf2ad08c739da05c9fd8de9067afb",
      image,
      //image.getHeaders()
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    const body = {
      data,
      url: {
        displayUrl: res.data.data.display_url,
        mediumUrl: res.data.data.medium.url,
        url: res.data.data.url,
        deleteUrl: res.data.data.delete_url
      }
    };
    console.log(body);
    const response = await axios.post(`${apiURL}media`, body, {
      headers: { authorization: token }
    });
    console.log(response);
    return response.data || {};
  } catch (error) {
    return error;
  }
};

export const getAllMedia = async query => {
  try {
    const response = await axios.get(`${apiURL}media?${query}`);
    return response.data || {};
  } catch (error) {
    return error;
  }
};

export const onPublishedFile = async (id, body) => {
  try {
    const response = await axios.put(`${apiURL}media/edit-media/${id}`, body);
    return response.data || {};
  } catch (error) {
    return error;
  }
};

export const getMediaByTag = async (tag, query) => {
  try {
    const response = await axios.get(`${apiURL}media/find/${tag}?${query}`);
    return response.data || {};
  } catch (error) {
    return error;
  }
};
